export default __webpack_public_path__ + "static/bookcase-c2ae6a909af574480be62e97c77c208b.svg";